// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1FcOb","label":"Labeled_label__3JU85","divider":"Labeled_divider__3rarP"};